


export default{
    state: {
        filterModelos: [],
        imgMapData: [],
        openMapaDetalle: false,
        modal: false,
        urlVideo: "",
        //lvl btns torres
        level:[],
        //active filter torre
        allElements:"off",

    },
    mutations: {
        _setFilterModelos(state, arrFilterModelos){
            state.filterModelos = arrFilterModelos
        },
        RESET_STATE(state) {
            state.filterModelos = '';
        },
        _setDataImageMap(state, arrDataImageMap){
            state.imgMapData = arrDataImageMap
        },
        _setMapDetail(state){
            state.openMapaDetalle = !state.openMapaDetalle
        },
        _setToggleModal(state){
            state.modal = !state.modal
        },
        _setUrlVideo(state, urlVideo){
            state.urlVideo = urlVideo
        },
        // //lvl btns torres
        _setLevel(state, level){
            state.level=level
        },
        _setClearLevel(state){
            state.level=[]
        },
        _setAllElements(state, level){
            state.allElements=level
        },
        _setClearAllElements(state){
            state.allElements="on"
        },

    },
    getters: {
        getStatusFilterModelos:(status) => {
            return status.filterModelos
        },
        getStatusDataImageMap: (state) => {
            return state.imgMapData
        },
        getStatusMapDetail: (state) => {
            return state.openMapaDetalle
        },
        getStatusToggleModal: (state) => {
            return state.modal
        },
        getStatusUrlVide: (state) => {
            return state.urlVideo
        },
        //add lvl btns torres
        getStatusLevel: (state) => {
            return state.level
        },
        getStatusAllElements: (state) => {
            return state.allElements
        }

    },
    actions: {
        resetState({commit}) {
            commit('RESET_STATE');
        },
        getFilterModelos(context, arrFilterModelos){
            context.commit("_setFilterModelos", arrFilterModelos)
        },
        getDataImageMap(context, arrDataImageMap){
            context.commit("_setDataImageMap", arrDataImageMap)
        },
        getMapDetail(context){
            context.commit("_setMapDetail")
        },
        getToggleModal(context){
            context.commit("_setToggleModal")
        },
        getUrlVide(context, urlVideo){
            context.commit("_setUrlVideo", urlVideo)
        },
        //add lvl btn torres
        async getLevel(context, level){
           await context.commit("_setLevel", level)
        },
        async getAllElements(context, level){
            context.commit("_setAllElements", level)
        },
        clearAllElements(context){
            context.commit("_setClearAllElements")
        },
    }
}